import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import LineSeperator from '../components/ui/LineSeperator';
import '../stylings/Syllabus.css';

const fallback = [
  { class: 'Class I', subject: 'English, Hindi, Maths, EVS', file: null, session: '2025-26' },
  { class: 'Class II', subject: 'English, Hindi, Maths, EVS', file: null, session: '2025-26' },
  { class: 'Class III', subject: 'English, Hindi, Maths, EVS, Computer', file: null, session: '2025-26' },
  { class: 'Class IV', subject: 'English, Hindi, Maths, EVS, Computer', file: null, session: '2025-26' },
  { class: 'Class V', subject: 'English, Hindi, Maths, EVS, Computer', file: null, session: '2025-26' },
  { class: 'Class VI', subject: 'English, Hindi, Maths, Science, Social Science', file: null, session: '2025-26' },
  { class: 'Class VII', subject: 'English, Hindi, Maths, Science, Social Science', file: null, session: '2025-26' },
  { class: 'Class VIII', subject: 'English, Hindi, Maths, Science, Social Science', file: null, session: '2025-26' },
  { class: 'Class IX', subject: 'English, Hindi, Maths, Science, Social Science', file: null, session: '2025-26' },
  { class: 'Class X', subject: 'English, Hindi, Maths, Science, Social Science', file: null, session: '2025-26' },
  { class: 'Class XI (Science)', subject: 'Physics, Chemistry, Maths/Biology, English, IP/PE', file: null, session: '2025-26' },
  { class: 'Class XI (Commerce)', subject: 'Accountancy, Business Studies, Economics, English, Maths/IP', file: null, session: '2025-26' },
  { class: 'Class XII (Science)', subject: 'Physics, Chemistry, Maths/Biology, English, IP/PE', file: null, session: '2025-26' },
  { class: 'Class XII (Commerce)', subject: 'Accountancy, Business Studies, Economics, English, Maths/IP', file: null, session: '2025-26' },
];

export default function Syllabus() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(process.env.REACT_APP_SYLLABUS_API)
      .then((res) => setData(res.data?.length ? res.data : fallback))
      .catch(() => setData(fallback))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout bannerTitle="Syllabus">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="Academic Syllabus 2025-26" />
          {loading ? (
            <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
          ) : (
            <div className="table-responsive mt-4">
              <table className="table table-striped table-hover syllabus-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Class</th>
                    <th>Subjects</th>
                    <th>Session</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td><strong>{row.class}</strong></td>
                      <td>{row.subject}</td>
                      <td><span className="session-badge">{row.session}</span></td>
                      <td>
                        {row.file
                          ? <a href={row.file} target="_blank" rel="noreferrer" className="download-btn"><i className="fas fa-download me-1"></i>PDF</a>
                          : <span className="coming-soon-badge">Coming Soon</span>
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
